import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';

import ControlledInput from '../inputs/ControlledInput';
import Button from '../buttons/Button';
import ImageUploaderComponent from '../inputs/ImageUploaderComponent';
import OptionButtonMenu from '../buttons/OptionButtonMenu';
import DeleteUserModal from './DeleteUserModal';
import { updateUser } from '../../redux/user/actions';

const Sidebar = ({ user, className = '' }) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const dispatch = useDispatch();

  const defaultValues = {
    name: user.name,
    phone: user.phone,
    email: user.email,
    web: user.website ? user.website : '',
  };
  const { control, handleSubmit, reset, watch } = useForm({ defaultValues });
  const [thereAreChanges, setThereAreChanges] = useState(false);
  const isPendingUpdate = useSelector(
    (state) => state.user.isUserUpdatePending || false
  );

  const name = watch('name');
  const phone = watch('phone');
  const email = watch('email');
  const web = watch('web');
  const logo = watch('logo');

  useEffect(() => {
    if (user) {
      reset({
        name: user.name,
        phone: user.phone,
        email: user.email,
        web: user.web ? user.web : '',
      });
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      if (
        logo !== undefined ||
        name !== user.name ||
        phone !== user.phone ||
        email !== user.email ||
        web !== user.web
      ) {
        setThereAreChanges(true);
      } else {
        setThereAreChanges(false);
      }
    }
  }, [name, phone, email, web, logo]);

  const onSubmit = async () => {
    const userObject = { ...user, email, phone, web, name };
    const userObjectWithUpdatedLogo = { ...userObject, logo: { id: logo?.id } };

    await dispatch(
      updateUser(user.id, logo ? userObjectWithUpdatedLogo : userObject)
    );
  };

  return (
    <div className={`c-user-sidebar ${className}`}>
      <div
        className="c-user-sidebar__title-container"
        style={{ display: 'flex' }}>
        <h2 className="c-user-sidebar__title">Miembro organizador</h2>
        <OptionButtonMenu
          style={{ marginRight: '-20px', marginTop: '-10px' }}
          options={[
            {
              id: 1,
              label: 'Eliminar Cuenta',
              action: () => {
                setOpenDeleteModal(true);
              },
            },
          ]}
        />
      </div>
      <h3>Tus datos</h3>

      <form onSubmit={handleSubmit(onSubmit)} className="c-user-sidebar__form">
        <ControlledInput
          control={control}
          name="name"
          label="Nombre"
          className="c-user-sidebar__input"
        />
        <ControlledInput
          control={control}
          name="phone"
          label="teléfono"
          className="c-user-sidebar__input"
        />
        <ControlledInput
          control={control}
          name="email"
          label="email"
          className="c-user-sidebar__input"
        />
        <ControlledInput
          control={control}
          name="web"
          label="web"
          className="c-user-sidebar__input"
        />
        <div className="c-user-sidebar__image-container">
          <ImageUploaderComponent
            recommendedSize="220px x 220px"
            maxSizeMB={2}
            label="Logo"
            control={control}
            name="logo"
            image={user.logo}
          />
        </div>
        <Button
          type="submit"
          className="c-user-sidebar__submit-button"
          isActive={thereAreChanges}
          isLoading={isPendingUpdate}>
          Guardar cambios
        </Button>
      </form>
      <DeleteUserModal
        isOpen={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
      />
    </div>
  );
};

export default Sidebar;
